export enum NOTIFICATION_NAMES {
  notConfirmedEmail,
  printWillBeDelivered,
  cardExpired,
  askingReturnPrinter,
  subscriptionCanceled,
  subscriptionRenewed,
  subscriptionWillExpireSoon,
  subscriptionExpired,
  checkCreditCard,
  printerWillBeLocked,
  printerLocking,
  printerLocked,
  printerWillBeUnlocked,
  printerWillBeSoon,
}
